import React from 'react';

export const EqVolcanoModal = {
  title: 'Volcano',
  body: (
    <div>
      <p>
        The Volcano link will display additional information if the earthquake was associated with a volcanic eruption. The information may include information such as the VEI index, morphology, and the effects of the eruption.
      </p>
    </div>
  ),
};
